import { useNavigate } from 'react-router-dom';

import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';
import { DATEV_MODALS } from 'src/pages/settings/components/datev/datev.constants';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

const DatevTableRowActions = ({
  record,
  handleModal,
  t,
}: {
  record: any;
  handleModal: (modal: string, record: any) => void;
  t: Function;
}) => {
  const navigate = useNavigate();
  const { canDelete, canEdit } = useUserCanManageDocument({
    createdBy: record.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.datevManagement,
  });

  return (
    <Popover
      elements={[
        {
          label: t('settings:datev.buttons.editDetails'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          ...(!canEdit && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
          handler: () => {
            if (canEdit) {
              navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.editDatev}&id=${record._id}`);
            }
          },
        },
        {
          label: t('settings:datev.buttons.deleteNumber'),
          icon: ICONS.trash,
          color: canDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,
          key: ICONS.trash,
          handler: () => {
            if (canDelete) {
              handleModal(DATEV_MODALS.delete, record);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default DatevTableRowActions;
